<template>
  <layout title="evaluations" :options="options" :rotas="rotas">
    <v-sheet
      :dark="$theme.dark"
      :light="$theme.light"
      class="expande-horizontal sheet-container pt-2"
    >
      <v-flex xs12 class="pr-1" lg3>
        <Filters :filter="filter" />
        <List :filtereds="filtereds" />
        <EmptyList
          :iniciarCadastro="iniciarCadastro"
          v-if="filtereds.length === 0"
        />
        <v-fab-transition>
          <v-btn
            @click="iniciarCadastro"
            :color="$theme.primary"
            dark
            absolute
            bottom
            right
            fab
            style="bottom: 30px;"
          >
            <v-icon color="#333">mdi-plus</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-flex>
      <v-flex v-if="$vuetify.breakpoint.lgAndUp" xs12 md9 lg9>
        <ViewForm v-if="get_evaluation.new || get_evaluation._id" />
      </v-flex>
      <v-dialog
        v-else
        transition="slide-x-transition"
        fullscreen
        :value="get_evaluation._id || get_evaluation.new ? true : false"
      >
        <v-card>
          <ViewForm />
        </v-card>
      </v-dialog>
    </v-sheet>
  </layout>
</template>

<script>
import EmptyList from "../components/EmptyList.vue";
import Filters from "../components/Filters.vue";
import List from "../components/List.vue";
import ViewForm from "../components/ViewForm.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      filter: {},
      options: [
        {
          nome: "Novo evaluation",
          action: this.iniciarCadastro,
          icon: "mdi-plus"
        }
      ],
      rotas: [
        {
          name: "Início",
          path: "/dashboard"
        },
        {
          name: "evaluations",
          path: "/evaluations"
        }
      ]
    };
  },
  components: {
    EmptyList,
    Filters,
    List,
    ViewForm
  },
  computed: {
    ...mapGetters([
      "get_evaluations_filtros",
      "getLoggedUser",
      "get_evaluation",
      "get_evaluations",
      "getPersonalizedLoading"
    ]),
    filtereds() {
      if (this.filter.search || this.filter.gender || this.filter.atipicity) {
        const res = this.get_evaluations.docs.filter(item => {
          return (
            (this.filter.search && item.student.nome &&
              item.student.nome
                .toLowerCase()
                .includes(this.filter.search.toLowerCase())) ||
            (this.filter.atipicity && item.obs &&
              item.obs
                .toLowerCase()
                .includes(this.filter.atipicity.toLowerCase())) ||
            (this.filter.gender && item.student.sexo &&
              item.student.sexo.includes(this.filter.gender))
          );
        });
        return res;
      } else {
        return this.get_evaluations.docs;
      }
    }
  },
  methods: {
    excluir_evaluation_dialog(item) {
      let text = "Deseja remover este evaluation?";
      this.createConfirmAction({
        message: text,
        icon: "mdi-close-circle",
        action: "excluir_evaluation",
        action_value: item
      });
    },
    getLinkById(id) {
      return this.getLinkById[id];
    },
    ...mapActions([
      "abre_modal_view_tenant",
      "listar_tenants",
      "listar_evaluations",
      "criar_estoque",
      "listar_evaluationcategorias",
      "criar_evaluation",
      "listar_estoques",
      "atualizar_evaluation",
      "setPersonalizedLoading",
      "createConfirmAction"
    ]),
    criarOuAtualizar() {
      if (this.get_evaluation._id) {
        this.atualizar_evaluation();
      } else {
        this.criar_evaluation();
      }
    },
    iniciarCadastro() {
      this.setPersonalizedLoading("animate__fadeOutTopRight");
      this.$store.commit("set_evaluation", { new: true });
      this.$store.commit("setLinks", []);
      this.setPersonalizedLoading("animate__fadeInUp");
    },
    createOrUpdate() {
      if (this.$refs.form.validate()) {
        if (this.get_evaluation._id) {
          this.atualizar_evaluation();
        } else {
          this.criar_evaluation();
        }
      }
    }
  },
  created() {
    this.listar_evaluations();
  }
};
</script>

<style scoped>
.sheet-container {
  min-height: 95vh;
  max-height: 95vh;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
.item-list {
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #1173ff;
}
</style>
